<template>
  <div v-if="!busy">
    <div class="row">
      <div class="col col-md-9 col-lg-8 m-auto">
        <template v-for="lead in leads">
          <b-card
            v-if="!isActioned(lead[0].id) || buyThis(lead[0].id)"
            :id="'leadcard-' + lead[0].id"
            :ref="'leadcard-' + lead[0].id"
            :key="lead[0].id"
            :class="[(buyThis(lead[0].id)) ? 'active-card': ['border', 'shadow'], 'mb-3', {'cursor-pointer':bulk, 'priority-lead': !olderThanNow(lead.priority_access)}]"
          >
            <b-card-header
              :class="['d-flex', 'align-items-center', {'view-details': (buyThis(lead[0].id))}]"
              @click.prevent.stop="checkLeadAvailability(lead)"
            >
              <b-badge
                v-if="!olderThanNow(lead.priority_access)"
                class="priority-lead-badge d-flex align-items-center rounded position-absolute"
              >
                {{ lead[0].priority_access }}
                <span class="float-left" v-html="$t('Priority Access')" />
                <spinner :small="true" />
              </b-badge>
              <span
                v-else-if="lead.inCoverage === 1"
                :class="['status-icon', 'mx-1', 'text-success', 'position-absolute', 'lead__coverage']"
                title="Within Coverage Area"
              >
                <font-awesome-icon :icon="'circle'" />
              </span>
              <span
                v-else
                :class="['status-icon', 'mx-1', 'text-info', 'position-absolute', 'lead__coverage']"
                :title="$t('Outside Coverage Area')"
              >
                <font-awesome-icon :icon="'circle'" />
              </span>

              <b-col :class="[{'priority-lead-title': !olderThanNow(lead.priority_access)}, 'col', 'col-12', 'd-inline-block', 'px-0', 'text-center']">
                <h2 class="h3 m-auto">
                  {{ lead.work_type_translation }}
                </h2>
                <h3 class="m-auto">
                  {{ leadShortAddress(lead.location, lead[0].postcode, lead.location_url) }}
                </h3>
              </b-col>
              <span v-if="buyThis(lead[0].id)" class="position-absolute close-card m-auto" @click.prevent.stop="close">
                <b-button class="close" variant="link">
                  <font-awesome-icon icon="times" />
                </b-button>
              </span>
            </b-card-header>
            <b-card-body class="py-3 px-4">
              <div
                v-if="!buyThis(lead[0].id)"
                class="row fadein-details"
                @click.prevent.stop="checkLeadAvailability(lead)"
              >
                <div class="col">
                  <dl class="row">
                    <dt class="col-5">
                      {{ $t('Date:') }}
                    </dt><dd class="col-7">
                      {{ $d(parseJsonDate(lead.dateReleased), 'shortWithTime') }}
                    </dd>
                    <dt class="col-5">
                      {{ $t('Timescale:') }}
                    </dt><dd class="col-7">
                      {{ getTimescaleTranslation(lead[0].question_answers) }}
                    </dd>
                    <dt class="col-5">
                      {{ $t('Leads Sold:') }}
                    </dt><dd class="col-7">
                      {{ $t('{n}/{max} {cta}', { n: lead[0].sold, max: lead[0].number_leads_requested, cta: leadsSold(lead[0].sold, lead[0].number_leads_requested) }) }}
                    </dd>
                  </dl>
                </div>
                <div class="col-3 d-flex buy-lead-mobile">
                  <div class="align-self-top">
                    <span class="d-block mb-2">{{ $t('Price:') }}<strong>{{ $n(lead.dashboardPrice, 'currency') }}</strong></span>
                    <array-checkbox v-if="bulk" v-model="selectedLeads" :val="lead" :limit="5">
                      {{ $t('Buy') }}
                    </array-checkbox>
                    <b-button
                      v-else
                      class="btn-lead-buy"
                      size="sm"
                      variant="outline-primary"
                      @click.prevent.stop="checkLeadAvailability(lead)"
                    >
                      {{ $t('View') }}
                    </b-button>
                  </div>
                </div>
              </div>

              <template v-if="!buyThis(lead[0].id)">
                <div class="row fadein-details" @click.prevent.stop="checkLeadAvailability(lead)">
                  <div class="col-12">
                    <strong>{{ $t('Qualification notes:') }}</strong> {{ lead[0].description }}
                  </div>
                </div>
              </template>

              <template v-if="checking && buyThis(lead[0].id)">
                <spinner>{{ $t('Checking availability') }}</spinner>
              </template>

              <template v-else-if="!checking && !available && buyThis(lead[0].id)" class="fadein-details">
                <b-alert :show="true" variant="danger" v-html="notAvailableReason.message" />
                <not-available @close="closeNotAvailable" />
              </template>

              <template v-else class="fadein-details">
                <div v-if="buyThis(lead[0].id) && notAvailableReason">
                  <b-alert v-if="notAvailableReason.email" :show="true" variant="warning">
                    <span v-if="validationSuccess">
                      {{ $t('Email sent, please check your inbox') }}
                    </span>
                    <span v-else>
                      {{
                        $t(
                          'Before you can buy leads, we need to verify your email address. Please check your Inbox at "{emailAddress}" and click the verification link.',
                          { emailAddress: company.company_user.email }
                        )
                      }}
                      <a class="text-link text-link-reset cursor-pointer" @click.prevent.stop="onSendToken">{{ $t('Resend verification link') }}</a>
                    </span>
                    <span v-if="timeLeftTillCanSendValidation !== null">
                      {{ $t('You must wait {timeLeftTillCanSendValidation} before resending the validation email', { timeLeftTillCanSendValidation }) }}
                    </span>
                  </b-alert>
                  <b-alert v-else :show="true" variant="warning" v-html="notAvailableReason.message" />
                </div>
                <buy-lead
                  v-if="buyThis(lead[0].id)"
                  :lead="lead"
                  :block="hasError"
                  @close="close"
                />
              </template>
            </b-card-body>
          </b-card>
        </template>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-9 col-lg-8 m-auto d-flex justify-content-between">
        <b-select v-if="items > 20" v-model="pageSize" :options="pageSizeOptions" class="w-auto page-size" />
        <b-pagination
          v-if="items/pageSize > 1"
          v-model="page"
          :total-rows="items"
          :per-page="pageSize"
          aria-controls="my-leads-table"
          align="right"
        />
      </div>
    </div>
  </div>
  <spinner v-else />
</template>

<script>
import Spinner from "@/components/animation/Spinner";
import {BUY_LEADS_RESULT_COUNT} from "@/store/mutation-types";
import BuyLead from "@/components/pane/BuyLead";
import LeadsSoldMixin from "@/imports/mixins/leadsSold";
import LeadShortAddressMixin from "@/imports/mixins/leadShortAddress";
import {
  ACTIONED_LEADS,
  BULK_BUY,
  CLEAR_SELECTED_LEADS,
  SELECTED_LEADS
} from "@/store/leads/mutation-types";
import NotAvailable from "@/components/pane/NotAvailable";
import ArrayCheckbox from "@/components/form/elements/ArrayCheckbox";
import leadErrors from "@/imports/mixins/leadErrors";
import gaEvent from "@/imports/mixins/gaEvent";
import OlderThanNow from "@/imports/mixins/olderThanNow";
import emailValidation from "@/imports/mixins/emailValidation";
import dates from '@/services/date';
import workTypeTranslation from "@/imports/mixins/workTypeTranslation";
import { captureError } from "@/services/userMonitoring";

export default {
  name: "MarketplaceLeadsList",
  components: {ArrayCheckbox, NotAvailable, BuyLead, Spinner},
  mixins:[LeadsSoldMixin, LeadShortAddressMixin, gaEvent, leadErrors, OlderThanNow, emailValidation, workTypeTranslation],
  props:['fields', 'sort'],
  data() {
    return {
      busy: false,
      items: 0,
      filterKey: 'buyLeads',
      leads: [],
      buy: null,
    }
  },
  computed: {
    filter: function() {
      return this.$store.getters.getFilter(this.filterKey);
    },
    preSelect: function() {
      return this.$store.state.leads.PRE_SELECT;
    },
    actionedLeads: {
      get: function() {
        return this.$store.state.leads.ACTIONED_LEADS;
      },
      set: function(value) {
        this.$store.commit(ACTIONED_LEADS, value);
      }
    },
    checking: function () {
      return this.$store.state.leads.AVAILABILITY_CHECK;
    },
    bulk: {
      get: function () {
        return this.$store.state.leads.BULK_BUY;
      },
      set: function (value) {
        this.$store.commit(BULK_BUY, value);
      }
    },
    selectedLeads: {
      get: function () {
        return this.$store.state.leads.SELECTED_LEADS;
      },
      set: function (value) {
        this.$store.commit(SELECTED_LEADS, value);
      }
    },
    page: {
      get: function() {
        return this.$route.query.page ?? 1;
      },
      set: function(value) {
        if ((this.$route.query.page && this.$route.query.page !== value) || (this.$route.query.page === undefined && value !== 1)) {
          this.$router.push({name:'buy-leads', query:{...this.$route.query, page:value}});
        }
      }
    },
    pageSize: {
      get: function() {
        return this.$store.state.BUY_LEADS_RESULT_COUNT;
      },
      set: function(value) {
        this.$store.commit(BUY_LEADS_RESULT_COUNT, value);
      }
    },
    company: function() {
      return this.$store.state.company.COMPANY;
    },
    pageSizeOptions: function() {
      const options = [10, 20, 40, 60];
      return options.map((amount) => ({value: amount, text: this.$tc("Show {n}", amount)}));
    },
  },
  methods: {
    parseJsonDate: dates.parseJsonDate,
    getLeads: async function() {
      this.busy = true;
      this.hasError = null;
      this.$api.leads.marketplace({...this.filter, page:this.page, pageSize:this.pageSize})
        .then((result) => {
          this.setMeta(result.data.meta);
          this.leads = result.data.data;
          if (this.preSelect && result.data.meta.preSelect !== null) {
            const selectedLead = this.leads.find((lead) => lead[0].id === result.data.meta.preSelect);
            this.checkLeadAvailability(selectedLead);
          }
        }).catch((e) => {
          if (e.response && e.response.status === 308) {
            this.$router.push({name:'my-lead', params: {code:e.response.data.redirect}});
          } else {
            captureError(e, {
              section: "marketplace",
              action: "get-leads",
              type: "api-request"
            });
          }
        }).finally(() => {
          this.busy = false;
        });
    },
    setMeta: function(metaData) {
      this.items = metaData.totalResults;
      this.pageSize = metaData.pageSize;
    },
    buyThis: function(id) {
      return this.buy !== null && this.buy[0].id === id;
    },
    refresh: function() {
      this.buy = null;
      this.getLeads();
    },
    close: function() {
      this.removeOrigin();
      this.buy = null;
      this.hasError = null;
      this.$store.commit(CLEAR_SELECTED_LEADS);
      this.$store.commit(BULK_BUY, false);
      this.notAvailableReason = null;
    },
    isActioned: function(lead) {
      return this.actionedLeads.find((actionedLead) => lead === actionedLead) !== undefined;
    },
    checkLeadAvailability: function(lead) {
      if(!this.buyThis(lead[0].id) && !this.hasError) {
        this.$store.dispatch('addLeadToBasket', lead);
        if (!this.bulk) {
          this.scrollCardIntoView(lead[0].id);
          this.buy = lead;
        }
      }
    },
    closeNotAvailable: function () {
      this.buy = null;
      this.removeOrigin();
      this.$store.commit(CLEAR_SELECTED_LEADS);
      this.$store.commit(BULK_BUY, false);
      this.notAvailableReason = null;
      this.$emit('refresh');
    },
    scrollCardIntoView: function(id) {
      setTimeout(() => {
        const card = this.$refs['leadcard-' + id];
        if (card !== undefined) {
          card.scrollIntoView(true);
          window.scrollBy(0, -70);
        }
      }, 10);
    }
  },
  watch: {
    filter: function() {
      this.removeOrigin();
      this.refresh();
    },
    page: function() {
      this.removeOrigin();
      this.refresh();
    },
    pageSize: function() {
      this.removeOrigin();
      this.refresh();
    },
    bulk: function() {
      this.buy = null;
    }
  },
  created: function() {
    this.refresh();
  }
}
</script>

<style scoped lang="scss">
.card {
  &-header {
    position: relative;

    .close-card {
      z-index: 1;
      right: 0;
      height: 100%;
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    h3 {
      font-size: $font-size-13;
    }
  }
  &-body {
    @include font-size($font-size-14);
  }
}

.lead__coverage {
  left: 15px;
}

.active-card {
  border: 1px transparent;
  box-shadow: 0 0 8px 0 rgba(1, 54, 82,  .45);
}

.priority-lead {
  .card-body {
    border-radius: $border-radius $border-radius 0 0;
    .card-header:first-child {
      border-radius: $border-radius $border-radius 0 0;
    }
  }

  &-badge {
    font-size: 10px;
    position: absolute;
    padding: 5px;
    background: linear-gradient(to right, $notification-icon-color, $priority-light-color);
    box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    color: $theme-primary;
    line-height: 1.3;
    text-align: left;
    left: -10px;
    max-width: 75px;

    ::v-deep .ripple--small {
      width: 25px;
      height: 25px;
    }
  }
  &-title {
    max-width: calc(100% - 95px);
    margin: 0 auto;
  }
}

@media only screen and (max-width: 374px) {
  .buy-lead-mobile,
  .buy-lead-details {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .buy-lead-mobile {
    justify-content: center;
    text-align: center;
    margin-bottom: 20px;
  }
}

</style>
